"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolateBig = void 0;
var big_js_1 = __importDefault(require("big.js"));
var d3_ease_1 = require("d3-ease");
var interpolateBig = function (_a) {
    var from = _a.from, to = _a.to, _b = _a.ease, ease = _b === void 0 ? d3_ease_1.easeLinear : _b;
    var gap = big_js_1.default(to).minus(from);
    return function (elapsed) {
        return big_js_1.default(from).plus(gap.mul(ease(elapsed)));
    };
};
exports.interpolateBig = interpolateBig;
//# sourceMappingURL=index.js.map